import React from "react";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import { tableContainerStyles } from "../../../assets/styles/tableContainer";
import { getAuthorizationForPage } from "../../../helpers/AuthorizationHelper";
import SessionHelper from "../../../helpers/SessionHelper";
import UnauthorizedPage from "../../UnauthorizedPage";
import SignInHistoryTable from "./SignInHistoryTable";

export default function SignInHistoryPage() {
  const permissions = SessionHelper.getUser().permissions;
  const authorization = getAuthorizationForPage(permissions, "signInHistory");

  return (
    <Container maxWidth={false} disableGutters style={tableContainerStyles}>
      <Grid>
        {authorization?.view ? <SignInHistoryTable /> : <UnauthorizedPage />}
      </Grid>
    </Container>
  );
}
